import React from 'react'
import copy from 'copy-text-to-clipboard'
import { useDispatch } from 'react-redux'
import { watch } from '../../core/reducers/watchlist'
import { Copy, Github, Globe, Reddit, Telegram, Twitter } from '../Icon'
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card'
import { Button } from '../ui/button'
import WatchStar from '../Watchlist/WatchStar'

function CoinSidebar({ coin, links = {}, platforms }) {
  const onClickCopy = (text) => {
    copy(text)
  }

  const dispatch = useDispatch()
  const onClickWatch = () => {
    if (coin) {
      dispatch(watch(coin))
    }
  }

  return (
    <div className="space-y-4">
      {/* Watchlist Button */}
      <Card>
        <CardContent className="p-4">
          <Button
            variant="outline"
            className="w-full justify-start gap-2"
            onClick={onClickWatch}
          >
            <WatchStar size="20" coin={coin} handleClick={false} />
            <span>Add to Watchlist</span>
          </Button>
        </CardContent>
      </Card>

      {/* Links */}
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Links</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2">
          {links.website && (
            <a
              href={links.website}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-3 px-3 py-2 rounded-lg text-walme-text hover:bg-walme-bg-elevated transition-colors"
            >
              <Globe className="w-5 h-5 text-walme-text-dim" />
              <span className="font-medium">Website</span>
            </a>
          )}

          {links.twitter && (
            <a
              href={links.twitter}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-3 px-3 py-2 rounded-lg text-walme-text hover:bg-walme-bg-elevated transition-colors"
            >
              <Twitter className="w-5 h-5 text-walme-text-dim" />
              <span className="font-medium">Twitter</span>
            </a>
          )}

          {links.telegram && (
            <a
              href={links.telegram}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-3 px-3 py-2 rounded-lg text-walme-text hover:bg-walme-bg-elevated transition-colors"
            >
              <Telegram className="w-5 h-5 text-walme-text-dim" />
              <span className="font-medium">Telegram</span>
            </a>
          )}

          {links.reddit && (
            <a
              href={links.reddit}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-3 px-3 py-2 rounded-lg text-walme-text hover:bg-walme-bg-elevated transition-colors"
            >
              <Reddit className="w-5 h-5 text-walme-text-dim" />
              <span className="font-medium">Reddit</span>
            </a>
          )}

          {links.github && (
            <a
              href={links.github}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-3 px-3 py-2 rounded-lg text-walme-text hover:bg-walme-bg-elevated transition-colors"
            >
              <Github className="w-5 h-5 text-walme-text-dim" />
              <span className="font-medium">Github</span>
            </a>
          )}
        </CardContent>
      </Card>

      {/* Platforms */}
      {platforms && Object.keys(platforms).length > 0 && (
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Contract Addresses</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2">
            {platforms.ethereum && (
              <div className="flex items-center justify-between px-3 py-2 rounded-lg bg-walme-bg-elevated">
                <div className="flex items-center gap-2">
                  <Copy
                    className="w-4 h-4 text-walme-text-dim cursor-pointer hover:text-walme-primary transition-colors"
                    onClick={() => onClickCopy(platforms.ethereum)}
                  />
                  <span className="font-medium text-sm">Ethereum</span>
                </div>
                <span className="text-xs text-walme-text-dim font-mono truncate max-w-[120px]">
                  {platforms.ethereum}
                </span>
              </div>
            )}

            {platforms['binance-smart-chain'] && (
              <div className="flex items-center justify-between px-3 py-2 rounded-lg bg-walme-bg-elevated">
                <div className="flex items-center gap-2">
                  <Copy
                    className="w-4 h-4 text-walme-text-dim cursor-pointer hover:text-walme-primary transition-colors"
                    onClick={() => onClickCopy(platforms['binance-smart-chain'])}
                  />
                  <span className="font-medium text-sm">BSC</span>
                </div>
                <span className="text-xs text-walme-text-dim font-mono truncate max-w-[120px]">
                  {platforms['binance-smart-chain']}
                </span>
              </div>
            )}

            {platforms.solana && (
              <div className="flex items-center justify-between px-3 py-2 rounded-lg bg-walme-bg-elevated">
                <div className="flex items-center gap-2">
                  <Copy
                    className="w-4 h-4 text-walme-text-dim cursor-pointer hover:text-walme-primary transition-colors"
                    onClick={() => onClickCopy(platforms.solana)}
                  />
                  <span className="font-medium text-sm">Solana</span>
                </div>
                <span className="text-xs text-walme-text-dim font-mono truncate max-w-[120px]">
                  {platforms.solana}
                </span>
              </div>
            )}

            {platforms.Avalanche && (
              <div className="flex items-center justify-between px-3 py-2 rounded-lg bg-walme-bg-elevated">
                <div className="flex items-center gap-2">
                  <Copy
                    className="w-4 h-4 text-walme-text-dim cursor-pointer hover:text-walme-primary transition-colors"
                    onClick={() => onClickCopy(platforms.Avalanche)}
                  />
                  <span className="font-medium text-sm">Avalanche</span>
                </div>
                <span className="text-xs text-walme-text-dim font-mono truncate max-w-[120px]">
                  {platforms.Avalanche}
                </span>
              </div>
            )}
          </CardContent>
        </Card>
      )}
    </div>
  )
}

export default CoinSidebar
